export enum ProcessingState {
  None,
  Empty,
  Loading,
  Success,
  Error,
}
